import { Capacitor } from "@capacitor/core";
import NativeOneSignal, { NotificationClickEvent } from "onesignal-cordova-plugin";
import ReactOneSignal from "react-onesignal";
import { getNotification } from "utils/device";
import { oneSignalKey } from "utils/env";

async function initWebOneSignal() {
  await ReactOneSignal.init({
    appId: oneSignalKey,
    serviceWorkerPath: "/push/onesignal/OneSignalSDKWorker.js",
    serviceWorkerUpdaterPath: "/push/onesignal/OneSignalSDKUpdaterWorker.js",
    serviceWorkerParam: { scope: "/push/onesignal/" },
    autoResubscribe: true,
  });
}

function initNativeOneSignal(callback: (e: NotificationClickEvent) => void) {
  NativeOneSignal.initialize(oneSignalKey);
  NativeOneSignal.Notifications.addEventListener("click", callback);
}

export async function oneSignalInit(callback: (e: NotificationClickEvent) => void) {
  return Capacitor.isNativePlatform() ? initNativeOneSignal(callback) : initWebOneSignal();
}

export async function getOptedIn() {
  return Capacitor.isNativePlatform()
    ? NativeOneSignal.User.pushSubscription.optedIn
    : ReactOneSignal.User.PushSubscription.optedIn;
}

export async function oneSignalLogin(userId: string) {
  if (Capacitor.isNativePlatform()) {
    NativeOneSignal.login(userId);
  } else {
    await ReactOneSignal.login(userId);
  }
}

export function oneSignalOptIn() {
  return Capacitor.isNativePlatform()
    ? NativeOneSignal.User.pushSubscription.optIn()
    : ReactOneSignal.User.PushSubscription.optIn();
}

export function oneSignalOptOut() {
  return Capacitor.isNativePlatform()
    ? NativeOneSignal.User.pushSubscription.optOut()
    : ReactOneSignal.User.PushSubscription.optOut();
}

export async function oneSignalShowNativePrompt() {
  const showNativePrompt = Capacitor.isNativePlatform()
    ? await NativeOneSignal.Notifications.requestPermission(true)
    : (await Notification.requestPermission()) === "granted";

  return showNativePrompt;
}

export function oneSignalCanRequestPermission() {
  return Capacitor.isNativePlatform()
    ? !NativeOneSignal.Notifications.hasPermission()
    : getNotification()?.permission === "default";
}

export function oneSignalPermissionGranted() {
  return Capacitor.isNativePlatform()
    ? NativeOneSignal.Notifications.hasPermission()
    : getNotification()?.permission === "granted";
}

export function oneSignalHasNotificationsDenied() {
  return Capacitor.isNativePlatform()
    ? !NativeOneSignal.Notifications.hasPermission()
    : getNotification()?.permission === "denied";
}
